export default __webpack_public_path__ + "static/media/Img0022.1f65fc56.png";